import Splide from '@splidejs/splide';

export default () => ({

    header: null,
    navItems: null,
    subNav: null,
    subNavCanvas: null,
    splide: null,

    activeElement: null,
    active: false,

    init() {
        // Take inventory
        this.header = document.querySelector('#header');
        this.navItems = this.$el.querySelectorAll('.menu_dp-link');
        this.subNav = this.$el.querySelector('#subnav');

        // Add event listeners for opening and closing subnav
        this.navItems.forEach(item => {
            item.addEventListener('mouseenter', this.triggerSubnav.bind(this));
            item.addEventListener('mouseleave', this.closeSubnav.bind(this));
        });
        this.subNav.addEventListener('mouseleave', this.closeSubnav.bind(this));
        this.subNav.addEventListener('transitionend', this.deactivateNav.bind(this));

        // Initiate slider in subnav
        this.splide = new Splide(this.subNav.querySelector('.splide'), {
            autoWidth: true,
            gap: '1.5rem',
            pagination: false,
            drag: true,
            focus: 0,
            omitEnd: true,
        });
        this.splide.on('overflow', (isOverflow) => {
            this.splide.options = {
                arrows: isOverflow,
                drag: isOverflow,
            };
        });
        this.splide.mount();
    },

    triggerSubnav(e) {
        this.openSubnav(e, this.active === true);
    },

    openSubnav(e, move = false) {
        const targetDimensions = e.target.getBoundingClientRect();
        const headerDimensions = this.header.getBoundingClientRect();

        // Activate the navigation with the current navitem
        this.activeElement = e.target;
        this.active = true;
        this.subNav.classList.remove('pointer-events-none');

        // Change max width depending on the type of subnav
        const isMega = e.target.querySelector('.subnav').classList.contains('subnav--is-mega');
        if (isMega) {
            this.subNav.classList.remove('max-w-[380px]')
            this.subNav.classList.add('max-w-full')
        } else {
            this.subNav.classList.add('max-w-[380px]')
            this.subNav.classList.remove('max-w-full')
        }

        // Populate the subnav with the content of the current navitem
        this.subNav.querySelector('#subnav_header').innerHTML = e.target.querySelector('.subnav__header').innerHTML;
        this.subNav.querySelector('#subnav_slider').innerHTML = e.target.querySelector('.subnav__slider').innerHTML;
        this.splide.refresh();
        const subNavDimensions = this.subNav.getBoundingClientRect();


        // Initiate transitions
        this.subNav.style.transition = move === true ? "transform .2s ease-in, opacity .3s ease-in-out, left .4s ease-out" : 'transform .2s ease-in, opacity .3s ease-in-out';

        // Fade in
        this.subNav.style.transform = 'translateY(0)';
        this.subNav.style.opacity = 100;

        // Move the subnav to the correct position
        this.subNav.style.left = this.subnavPosition(
            isMega,
            targetDimensions.width,
            targetDimensions.left,
            subNavDimensions.width,
            headerDimensions.left,
            headerDimensions.width
        ) + 'px';
    },

    closeSubnav(e) {
        if (!this.subNav.contains(e.relatedTarget)) {
            this.activeElement = null;
            this.subNav.style.transform = 'translateY(-10px)';
            this.subNav.style.opacity = 0;
        }
    },

    deactivateNav(e) {
        if (this.activeElement === null) {
            this.active = false;
            this.subNav.classList.add('pointer-events-none');
        }
    },

    subnavPosition(isMegaMenu = true, navItemWidth, navItemLeft, subnavWidth, headerLeft, headerWidth) {
        if (subnavWidth >= headerWidth) {
            return 0;
        } else {
            const subnavLeft = ((navItemLeft - headerLeft) / (headerWidth - navItemWidth)) * (headerWidth - subnavWidth);
            return subnavLeft + subnavWidth > headerLeft + headerWidth
                ? headerLeft + headerWidth - subnavWidth
                : subnavLeft;
        }
    }
})

